import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form, Input, Button, Message } from '@arco-design/web-react'
import { confirmPasswordResetApi } from '@/api/user'

export default function PasswordResetConfirm() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const email = params.get('email') || ''
  const token = params.get('token') || ''

  const handleSubmit = async (values: { password: string; password2: string }) => {
    if (values.password !== values.password2) {
      Message.error(t('auth.passwordMismatch'))
      return
    }
    setLoading(true)
    try {
      await confirmPasswordResetApi(email, token, values.password)
      Message.success(t('auth.passwordResetSuccess'))
      navigate('/?auth=login')
    } catch (err: unknown) {
      Message.error(err instanceof Error ? err.message : t('auth.passwordResetFailed'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--landing-bg)]">
      <div className="w-full max-w-[440px] landing-auth-glass rounded-2xl p-8">
        <h1 className="text-xl font-semibold mb-4">{t('auth.resetPasswordTitle')}</h1>
        {(!email || !token) ? (
          <div className="py-6 text-sm text-red-500">{t('auth.invalidResetLink')}</div>
        ) : (
          <Form onSubmit={handleSubmit} layout="vertical">
            <Form.Item field="password" label={t('auth.newPassword')} rules={[{ required: true, message: t('auth.requiredNewPassword') }]}>
              <Input.Password placeholder={t('auth.placeholderPasswordMin')} size="large" />
            </Form.Item>
            <Form.Item field="password2" label={t('auth.confirmPassword')} rules={[{ required: true, message: t('auth.requiredConfirmPassword') }]}>
              <Input.Password placeholder={t('auth.placeholderConfirmAgain')} size="large" />
            </Form.Item>
            <Button type="primary" htmlType="submit" size="large" loading={loading} long>
              {t('auth.submit')}
            </Button>
          </Form>
        )}
        <div className="mt-6 text-sm">
          <Link to="/?auth=login" className="text-[var(--brand-primary)]">{t('auth.backToLogin')}</Link>
        </div>
      </div>
    </div>
  )
}
